import { useTranslation } from "react-i18next";
import BottomPanel from "../app/panels/BottomPanel";
import { JuisciPrivacyPolicy } from "./JuisciPrivacyPolicy";

/**
 * The privacy policy of Juisci in a bottom sheet, for the objection screen
 * (O1, O2), so that reading it never leaves the signup (Figma
 * O1.signup-objection.privacy, 4902:14417). The text is long: the sheet takes
 * 90% of the screen and scrolls under the panel's bottom fog.
 */
export function PrivacyPolicySheet({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <BottomPanel
      isOpen={isOpen}
      onClose={onClose}
      backdropBlur
      displayCloseButton
      height="90dvh"
    >
      {/* The title starts 16px under the close button, which sits 20px below
          the top edge of the panel. */}
      <div className="flex flex-col gap-4 px-6 pb-4 pt-11">
        <h2 className="m-0 font-dm-sans text-heading-lg font-semibold text-ds-mint-900">
          {t("Privacy policy")}
        </h2>
        {isOpen && <JuisciPrivacyPolicy />}
      </div>
    </BottomPanel>
  );
}
